import {StaticDataService} from '../../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {IoFilterDateRangesEnum} from '../../../../models/enum/io-filter-date-ranges.enum';
import {OrganizerTimeModel} from './organizer-time.model';

export class OrganizerFilterDateRangeHandler {
  static lifeTimeStartDate = new Date(2016, 0, 1);

  items: EnumValidValueItemModel[];

  static getTimeFromRange(timeEnum: EnumValidValueItemModel): OrganizerTimeModel {
    const todayDate = new Date(Date.now());
    const year = todayDate.getFullYear();

    let startDate: Date = null;
    let endDate: Date = null;
    let currentQuarterModel: OrganizerTimeModel = null;
    let lastQuarterDate: Date = null;

    switch (timeEnum.ValidValueItemId) {
      case IoFilterDateRangesEnum.CurrentMonth:
        startDate = new Date(year, todayDate.getMonth(), 1);
        endDate = todayDate;
        return new OrganizerTimeModel(startDate.getTime(), endDate.getTime());
      case IoFilterDateRangesEnum.LastMonth:
        startDate = new Date(todayDate.getFullYear(), todayDate.getMonth() - 1, 1);
        endDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), 0);
        return new OrganizerTimeModel(startDate.getTime(), endDate.getTime());
      case IoFilterDateRangesEnum.PreviousMonth:
        startDate = new Date(todayDate.getFullYear(), todayDate.getMonth() - 2, 1);
        endDate = new Date(todayDate.getFullYear(), todayDate.getMonth() - 1, 0);
        return new OrganizerTimeModel(startDate.getTime(), endDate.getTime());
      case IoFilterDateRangesEnum.LastYearMTD:
        return new OrganizerTimeModel(new Date(year - 1, todayDate.getMonth(), 1).getTime(), new Date(year - 1, todayDate.getMonth(), todayDate.getDate()).getTime());
      case IoFilterDateRangesEnum.CurrentQuarter:
        currentQuarterModel = this.determineQuarter(todayDate);
        currentQuarterModel.end = new Date().getTime();
        return currentQuarterModel;
      case IoFilterDateRangesEnum.LastQuarter:
        lastQuarterDate = new Date(todayDate.getFullYear(), todayDate.getMonth() - 3, todayDate.getDay());
        return this.determineQuarter(lastQuarterDate);
      case IoFilterDateRangesEnum.PreviousQuarter:
        lastQuarterDate = new Date(todayDate.getFullYear(), todayDate.getMonth() - 6, todayDate.getDay());
        return this.determineQuarter(lastQuarterDate);
      case IoFilterDateRangesEnum.LastYearQTD:
        const lyqtd = new Date(year - 1, todayDate.getMonth(), todayDate.getDate());
        currentQuarterModel = this.determineQuarter(lyqtd, true);
        return currentQuarterModel;
      case IoFilterDateRangesEnum.CurrentYear:
        return new OrganizerTimeModel(new Date(year, 0, 1).getTime(), todayDate.getTime());
      case IoFilterDateRangesEnum.LastYear:
        return new OrganizerTimeModel(new Date(year - 1, 0, 1).getTime(), new Date(year - 1, 12, 0).getTime());
      case IoFilterDateRangesEnum.PreviousYear:
        return new OrganizerTimeModel(new Date(year - 2, 0, 1).getTime(), new Date(year - 2, 12, 0).getTime());
      case IoFilterDateRangesEnum.LastYearYTD:
        return new OrganizerTimeModel(new Date(year - 1, 0, 1).getTime(), new Date(year - 1, todayDate.getMonth(), todayDate.getDate()).getTime());
      case IoFilterDateRangesEnum.LifeTime:
        return new OrganizerTimeModel(this.lifeTimeStartDate.getTime(), todayDate.getTime());
    }
  }

  private static determineQuarter(date: Date, isToDate: boolean = false): OrganizerTimeModel {
    const todayDate = new Date();
    const quarter = Math.floor((date.getMonth() / 3)) + 1;
    const startDate = new Date(date.getFullYear(), (quarter - 1) * 3, 1);
    const endDate = new Date(date.getFullYear(), startDate.getMonth() + 3, 0);
    const timeModel: OrganizerTimeModel = new OrganizerTimeModel(startDate.getTime(), endDate.getTime());
    timeModel.quarter = quarter;

    if (isToDate && (date.getMonth() >= todayDate.getMonth() && date.getDate() >= todayDate.getDate())) {
      const tmp = new Date(timeModel.end);
      tmp.setMonth(todayDate.getDate());
      tmp.setMonth(todayDate.getMonth());
      timeModel.end = tmp.getTime();
    }

    return timeModel;
  }

  constructor(private staticDataService: StaticDataService) {
    if (this.staticDataService.validValueItems && this.staticDataService.validValueItems.length > 0) {
      this.items = this.staticDataService.getValidValueItemsByItemIds(this.getDateRangeItems());
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe(
        {
          complete: () => {
            this.items = this.staticDataService.getValidValueItemsByItemIds(this.getDateRangeItems());
          }
        }
      );
    }
  }

  getDateRangeItems(): string[] {
    const rangeIds: string[] = [];
    rangeIds.push(IoFilterDateRangesEnum.CurrentMonth);
    rangeIds.push(IoFilterDateRangesEnum.LastMonth);
    rangeIds.push(IoFilterDateRangesEnum.PreviousMonth);
    rangeIds.push(IoFilterDateRangesEnum.LastYearMTD);
    rangeIds.push(IoFilterDateRangesEnum.CurrentQuarter);
    rangeIds.push(IoFilterDateRangesEnum.LastQuarter);
    rangeIds.push(IoFilterDateRangesEnum.PreviousQuarter);
    rangeIds.push(IoFilterDateRangesEnum.LastYearQTD);
    rangeIds.push(IoFilterDateRangesEnum.CurrentYear);
    rangeIds.push(IoFilterDateRangesEnum.LastYear);
    rangeIds.push(IoFilterDateRangesEnum.PreviousYear);
    rangeIds.push(IoFilterDateRangesEnum.LastYearYTD);
    rangeIds.push(IoFilterDateRangesEnum.LifeTime);
    rangeIds.push(IoFilterDateRangesEnum.UserDefined);
    return rangeIds;
  }
}
